const API_ERROR_CODE_MAP = {
  EMAIL_ALREADY_EXISTS: "admin.annotators.modals.validation.emailAlreadyUsed",
  PHONE_INVALID_FORMAT: "admin.annotators.modals.validation.phoneSenegalMobile",
};

const API_ERROR_MESSAGE_MAP = {
  "User already exists with this email_id.": "admin.annotators.modals.validation.emailAlreadyUsed",
  "user id is required.": "superAdmin.modals.resetPasswordForm.apiErrors.userIdRequired",
  "old password is required.": "superAdmin.modals.resetPasswordForm.apiErrors.oldPasswordRequired",
  "new password is required.": "superAdmin.modals.resetPasswordForm.apiErrors.newPasswordRequired",
  "Old password is incorrect.":
    "superAdmin.modals.resetPasswordForm.apiErrors.oldPasswordIncorrect",
  "User not found": "superAdmin.modals.resetPasswordForm.apiErrors.userNotFound",
  "Something went wrong": "superAdmin.modals.resetPasswordForm.apiErrors.somethingWentWrong",
  "You are not authorized to reset this user's password.":
    "superAdmin.modals.resetPasswordForm.apiErrors.notAuthorized",
  "user_id is required.": "admin.annotators.modals.errors.deleteUserIdRequired",
  "Missing 'current_user_id' query parameter.":
    "admin.annotators.modals.errors.deleteCurrentUserRequired",
  "Failed to delete user": "admin.annotators.modals.errors.deleteUser",
};

export function isEmailAlreadyExistsError(result) {
  if (!result || result.status === "success") return false;
  return (
    result.code === "EMAIL_ALREADY_EXISTS" ||
    result.message === "User already exists with this email_id."
  );
}

export function isPhoneInvalidFormatError(result) {
  if (!result || result.status === "success") return false;
  return result.code === "PHONE_INVALID_FORMAT";
}

export function translateApiMessage(message, codeOrT, maybeT, emptyFallback) {
  let code;
  let t;
  let fallbackWhenEmpty;

  if (typeof codeOrT === "function") {
    code = undefined;
    t = codeOrT;
    fallbackWhenEmpty = maybeT;
  } else {
    code = codeOrT;
    t = maybeT;
    fallbackWhenEmpty = emptyFallback;
  }

  if (!message && fallbackWhenEmpty) {
    return fallbackWhenEmpty;
  }

  const keyFromCode = code ? API_ERROR_CODE_MAP[code] : undefined;
  const keyFromMessage = message ? API_ERROR_MESSAGE_MAP[message] : undefined;
  const key = keyFromCode || keyFromMessage;

  if (key && t) {
    return t(key, message || "");
  }

  return message || "";
}
